import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";

const items = [
  {
    name: "Sukesh",
    role: "Wedding · Vadodara",
    text: "We had a wonderful experience with the team. They were creative, supportive and managed every detail with care.",
  },
  {
    name: "Jay",
    role: "Wedding Décor",
    text: "Shree Event Planner handled our wedding décor beautifully. The team understood our vision and made everything look elegant, traditional and well organised.",
  },
  {
    name: "Misha",
    role: "Reception",
    text: "Our reception setup was exactly how we imagined it. The stage, lighting and floral décor looked stunning, and the whole event felt very smooth.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative section-pad" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <div className="flex items-center justify-center gap-3 mb-6">
            <span className="h-px w-10 bg-gold" />
            <span className="text-xs uppercase tracking-[0.3em] text-gold font-medium">Testimonials</span>
            <span className="h-px w-10 bg-gold" />
          </div>
          <h2
            className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight"
            data-testid="testimonials-heading"
          >
            What our <span className="italic text-gold-gradient">clients</span> say.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {items.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              whileHover={{ y: -8 }}
              className="glass-gold rounded-2xl p-8 relative overflow-hidden group"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute -top-2 -right-2 text-gold/10 w-24 h-24" strokeWidth={0.5} />
              <div className="flex gap-1 mb-5">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} size={14} className="fill-gold text-gold" />
                ))}
              </div>
              <p className="font-serif text-xl text-ivory/90 leading-relaxed mb-8 italic font-light">
                "{t.text}"
              </p>
              <div className="gold-divider mb-5" />
              <div>
                <p className="font-serif text-lg text-gold-gradient">{t.name}</p>
                <p className="text-[11px] uppercase tracking-[0.25em] text-ivory/50 mt-1">{t.role}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
